import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@lentau/ui-kit/core/tokens/window';
import { BrowserApiSupportService } from '@lentau/ui-kit/core/services/browser-api-support/browser-api-support.service';
import { MAIN_FAKE_REGIONS, QA_STANDS, SplitHostValue, TESTING_STAND_DOMAIN } from '@lentau/city/shared/constants';

@Injectable({ providedIn: 'root' })
export class CityNavigateHelperService {
  constructor(
    @Inject(WINDOW) private window: Window,
    private browserApi: BrowserApiSupportService
  ) {}

  public navigate(newHost: string): void {
    const { protocol, pathname, search } = this.window.location;
    const newUrl = protocol + '//' + newHost + pathname + search;

    this.window.location.replace(newUrl);
  }

  public get regionByUrl(): string | null {
    const hostName: string = this.browserApi.getHostName();
    const firstDot: number = hostName.indexOf('.');
    return firstDot === -1 ? null : hostName.slice(0, firstDot);
  }

  // Определяет есть ли слаг города в домене
  // Для QA стендов задачётся false
  // По этому параметру также задаётся x-domain
  public get urlHasCitySlug(): boolean {
    const regionByUrl: string | null = this.regionByUrl;

    if (
      !regionByUrl ||
      MAIN_FAKE_REGIONS.includes(regionByUrl) ||
      QA_STANDS.some((qaStand: string) => regionByUrl.includes(qaStand))
    )
      return false;

    return !!regionByUrl;
  }

  public get splitHostValue(): number {
    const hostName: string = this.browserApi.getHostName();
    return hostName.includes(TESTING_STAND_DOMAIN) ? SplitHostValue.test : SplitHostValue.production;
  }
}
